module.exports = __webpack_public_path__ + "img/jellyfish.b4cb7e14.png";